// Action types for fetching orders
export const FETCH_BULK_ORDERS_COUNT_REQUEST = 'FETCH_BULK_ORDERS_COUNT_REQUEST';
export const FETCH_BULK_ORDERS_COUNT_SUCCESS = 'FETCH_BULK_ORDERS_COUNT_SUCCESS';
export const FETCH_BULK_ORDERS_COUNT_FAILURE = 'FETCH_BULK_ORDERS_COUNT_FAILURE';
export const FETCH_BULK_ORDERS_COUNT_REST = 'FETCH_BULK_ORDERS_COUNT_REST';
// Fetch data actions
export const fetchBulkOrdersCountRequest = (payload) => ({
    type: FETCH_BULK_ORDERS_COUNT_REQUEST,
    payload,
});
export const fetchBulkOrdersCountSuccess = (payload) => ({
    type: FETCH_BULK_ORDERS_COUNT_SUCCESS,
    payload,
});
export const fetchBulkOrdersCountFailure = (error) => ({
    type: FETCH_BULK_ORDERS_COUNT_FAILURE,
    payload: error,
});
export const fetchBulkOrdersCountRest = () => ({
    type: FETCH_BULK_ORDERS_COUNT_REST,
});
